import Vue from 'vue'
import Router from 'vue-router'



//Dashboard
import Dashboard from '@/components/admin/dashboard/Dashboard'
//Auth
import Setup from '@/components/admin/authentication/Setup'
import SetupSuccess from '@/components/admin/authentication/Success'

//Sales
import AddSales from '@/components/admin/sales/AddSales'
import Sales from '@/components/admin/sales/Sales'
import EditSales from '@/components/admin/sales/EditSales'
import SalesReport from '@/components/admin/sales/SalesReport'
import ViewOrder from '@/components/admin/sales/ViewOrder'

// Expenses
import AddExpenses from '@/components/admin/expenses/AddExpenses'
import EditExpense from '@/components/admin/expenses/EditExpense'
import Expenses from '@/components/admin/expenses/Expenses'
import ExpenseType from '@/components/admin/expenses/ExpenseType'
import AddExpenseType from '@/components/admin/expenses/AddExpenseType'
import ExpenseReport from '@/components/admin/expenses/ExpenseReport'

// Stock
import AddItem from '@/components/admin/stock/AddItem'
import EditItem from '@/components/admin/stock/EditItem'
import Items from '@/components/admin/stock/Items'
import ItemCategories from '@/components/admin/stock/ItemCategories'
import AddItemCategory from '@/components/admin/stock/AddItemCategory'
import StockReport from '@/components/admin/stock/StockReport'

//Report
import Report from '@/components/admin/report/Report'

//POS
import Pos from '@/components/admin/pos/Pos'
import Tables from '@/components/admin/pos/Tables'
import PosCatProduct from '@/components/admin/pos/PosCatProduct'
import PosCategoryProduct from '@/components/admin/pos/PosCategoryProduct'
import PosCheckout from '@/components/admin/pos/Checkout'
import PosSuccess from '@/components/admin/pos/Success'

//Settings
import Settings from '@/components/admin/settings/Settings'


import firebase from 'firebase'
Vue.use(Router)

const router = new Router({
  mode:'history',
  routes: [    
    {
      path: '/',
      name: 'Setup',
      component: Setup
    },
    {
      path: '/pos',
      name: 'Pos',
      component: Pos,
      meta:{
        requiresAuth:true       
      }
    },
    {
      path: '/setup-succss',
      name: 'SetupSuccess',
      component: SetupSuccess
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
      meta:{
        requiresAuth:true
      }
    },    
    {
      path: '/add-sales',
      name: 'AddSales',
      component: AddSales,
      meta:{
        requiresAuth:true
      }
    },
    {
      path: '/edit-sales/:id',
      name: 'EditSales',
      component: EditSales,
      meta:{
        requiresAuth:true
      }
    },
    {
      path: '/sales-report',
      name: 'SalesReport',
      component: SalesReport,
      meta:{
        requiresAuth:true
      }
    },
    {
      path: '/sales',
      name: 'Sales',
      component:Sales,
      meta:{
        requiresAuth:true
      }
    },   
    {
      path: '/view-order',
      name: 'ViewOrder',
      component:ViewOrder,
      meta:{
        requiresAuth:true
      }
    },
    {
      path: '/add-expenses',
      name: 'AddExpenses',
      component: AddExpenses,
      meta:{
        requiresAuth:true
      }
    },   
    {
      path: '/expenses-type',
      name: 'ExpenseType',
      component: ExpenseType,
      meta:{
        requiresAuth:true
      }
    },
    {
      path: '/add-expense-type',
      name: 'AddExpenseType',
      component: AddExpenseType,
      meta:{
        requiresAuth:true
      }
    },
    {
      path: '/expenses-report',
      name: 'ExpenseReport',
      component: ExpenseReport,
      meta:{
        requiresAuth:true
      }
    },
    {
      path: '/expenses',
      name: 'Expenses',
      component: Expenses,
      meta:{
        requiresAuth:true
      }
    },
    {
      path: '/edit-expenses/:id',
      name: 'EditExpense',
      component: EditExpense,
      meta:{
        requiresAuth:true
      }
    },  
    {
      path: '/add-item',
      name: 'AddItem',
      component: AddItem,
      meta:{
        requiresAuth:true
      }
    },
    {
      path: '/add-item-category',
      name: 'AddItemCategory',
      component: AddItemCategory,
      meta:{
        requiresAuth:true
      }
    },
    {
      path: '/edit-item/:id',
      name: 'EditItem',
      component: EditItem,
      meta:{
        requiresAuth:true
      }
    },
    {
      path: '/items',
      name: 'Items',
      component: Items,
      meta:{
        requiresAuth:true
      }
    },
    {
      path: '/stock-report',
      name: 'StockReport',
      component: StockReport,
      meta:{
        requiresAuth:true
      }
    },
    {
      path: '/item-categories',
      name: 'ItemCategories',
      component: ItemCategories,
      meta:{
        requiresAuth:true
      }
    },
    {
      path: '/report',
      name: 'Report',
      component: Report,
      meta:{
        requiresAuth:true
      }
    }, 
    {
      path: '/settings',
      name: 'Settings',
      component: Settings,
      meta:{
        requiresAuth:true
      }
    },   
    {
      path: '/tables',
      name: 'Tables',
      component: Tables,
      meta:{
        requiresAuth:true       
      }
    },
    {
      path: '/pos/product-category/:category',
      name: 'PosCatProduct',
      component: PosCatProduct,
      meta:{
        requiresAuth:true       
      }  
    },     
    {
      path: '/pos/checkout',
      name: 'PosCheckout',
      component: PosCheckout,
      meta:{
        requiresAuth:true       
      }  
    },     
    {
      path: '/pos/product-categorys/:category',
      name: 'PosCategoryProduct',
      component: PosCategoryProduct,
      meta:{
        requiresAuth:true       
      }  
    },
    {
      path: '/pos/success',
      name: 'PosSuccess',
      component: PosSuccess,
      meta:{
        requiresAuth:true       
      }  
    }, 
  
  ]
})

router.beforeEach((to,from,next) => {
  let currentUser=firebase.auth().currentUser;
  let requiresAuth=to.matched.some(record=>record.meta.requiresAuth);


  if(requiresAuth && !currentUser) next('/')
  //else if (!requiresAuth && currentUser) next('dashboard')
  else next()
});

// Vue Meta
import Meta from 'vue-meta';
Vue.use(Meta);


export default router



// WEBPACK FOOTER //
// ./src/router/index.js